export const origins = ['STANDARD_GLOBAL', 'STANDARD_SPECIFIC', 'CUSTOM'];
export const minimumNumberOfPointsForCalibration = 12;
export const AUTOMATIC_ANALYSIS_STATUS_NOT_STARTED = 'NOT_STARTED';
export const AUTOMATIC_ANALYSIS_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const AUTOMATIC_ANALYSIS_STATUS_DONE = 'DONE';
export const WIDTH_PARTIAL_CODE = 'LARGEUR_ET_SURFACE';
